/* jshint esversion: 6 */

import React, {
  Fragment,
} from 'react';
import PropTypes from 'prop-types';
import UserRoleContainer from './subcomponents/user/UserRole/UserRoleContainer';
import CreateRole from './subcomponents/user/UserRole/CreateRole';
import ListRoles from './subcomponents/user/UserRole/ListRoles';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  useLocation
} from "react-router-dom";

class UserRole extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let url = new URL(window.location.href)
    return (
      <Router basename={url.pathname} history={history}>
        <div>
          <Switch>
            <Route path="/new" render={(props) => <CreateRole {...props} action={this.props.action} authenticityToken={this.props.authenticityToken} />}/>
            <Route path="/" render={(props) => <ListRoles {...props} role={this.props.userRoles} action={this.props.action} authenticityToken={this.props.authenticityToken} backAction={this.props.backAction} />}/>
          </Switch>
        </div>
      </Router>
    )
  }
}

export default UserRole;
